<template>
  <transition name="fade">
    <div
      class="modal is-active"
	  :class="modalClass"
      ref="modal"
    >
      <div
        class="modal-background"
        @click="close()"
      ></div>
      <div
        :class="`modal-content${large ? ' modal-lg' : ''}`"
        v-if="!card"
      >
        <slot></slot>
      </div>
      <slot v-if="card"></slot>
      <button
        type="button"
        class="modal-close"
        @click="close()"
        v-if="!permanent && !card"
      ></button>
    </div>
  </transition>
</template>

<script>
import EventEmitter from "../helpers/EventEmitter"

export default {
  name: "Modal",
  props: {
    large: { default: false, type: Boolean },
    permanent: { default: false, type: Boolean },
    card: { default: true, type: Boolean },
    closeOnOutsideClick: { type: Boolean, default: true },
	modalClass: { type: String, default: "" },
  },

  mounted() {
    EventEmitter.listen("keyup", this.keyUpHandler)
    const items = document.querySelectorAll("html")
    items.forEach((item) => item.classList.add("overflow-hidden"))
  },

  beforeUnmount() {
    EventEmitter.remove("keyup", this.keyUpHandler)
    const items = document.querySelectorAll("html")
    items.forEach((item) => item.classList.remove("overflow-hidden"))
  },

  methods: {
    close() {
      if (!this.closeOnOutsideClick) {
        return
      }
      if (!this.permanent) {
        this.$emit("close")
      }
    },

    keyUpHandler(e) {
      if ((e.code === 27 || e.keyCode === 27) && !this.permanent) {
        // escape key maps to keycode `27`
        this.close()
      }
    },
  },
}
</script>
